import { Pencil } from 'lucide-react';
import React from 'react';
import FormPubUpdate from './FormPubUpdate';
import { IconButton, FormDrawer } from '../ui';

export default function UpdatePub(props: { Pub: any, handleFunction: any }) {
    const [open, setOpen] = React.useState(false);

    return (
        <div>
            <IconButton size={32} color="warning" tooltip="Modifier cette publicité" onClick={() => setOpen(true)}>
                <Pencil size={16} />
            </IconButton>
            <FormDrawer
                open={open}
                onClose={() => setOpen(false)}
                title={`Modification de la publicité ${props.Pub?.Libelle || ''}`}
                hint="Les informations existantes sont pré-remplies. Modifiez les champs souhaités puis enregistrez."
            >
                <FormPubUpdate handleFunction={() => { setOpen(false); props.handleFunction() }} pub={props.Pub} />
            </FormDrawer>
        </div>
    );
}
